const Resources = {

    table_headers: [
        { 
          text: 'Time off',  
          align: 'start', 
          value: 'time_off'
        },
        {   
            text: 'Start date',        
            value: 'start_date' 
        },
        {   
            text: 'End date',        
            value: 'end_date' 
        },
        { 
            text: 'Hours',        
            value: 'hours'
        },
        { 
            text: 'Reason',        
            value: 'reason'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Associates',
            href:   '/associates',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Associate Day Off',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
    ],

}

export default Resources;